export default class {

    /**
     * constructor
     */
    constructor() {
        this.breakpoint = {
            s: 639,
            m: 979
        };
        this.switchFlag = '';
        this.switchS = new CustomEvent('switch-s');
        this.switchM = new CustomEvent('switch-m');
        this.switchL = new CustomEvent('switch-l');
        this.setEvent();
        this.setFillHeight();
        this.checkSwitcher();
    }

    /**
     * setEvent
     */
    setEvent(){
        document.addEventListener('app-load', () => {
            this.setFillHeight();
            this.checkSwitcher();
        });
        document.addEventListener('app-resize', () => {
            this.setFillHeight();
            this.checkSwitcher();
        });
    }

    /**
     * setFillHeight
     */
    setFillHeight(){
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh',`${vh}px`);
    }

    /**
     * checkSwitcher
     */
    checkSwitcher(){
        if (this.getWinW() < this.breakpoint.s && this.switchFlag !== 's') {
            this.switchFlag = 's';
            document.dispatchEvent(this.switchS);
        } else if (this.getWinW() >= this.breakpoint.s && this.getWinW() < this.breakpoint.m && this.switchFlag !== 'm') {
            this.switchFlag = 'm';
            document.dispatchEvent(this.switchM);
        } else if (this.getWinW() >= this.breakpoint.m && this.switchFlag !== 'l') {
            this.switchFlag = 'l';
            document.dispatchEvent(this.switchL);
        };
    }

    /**
     * getWinW
     * @return {Number} window幅
     */
    getWinW(){
        return window.innerWidth;
    }

    /**
     * getWinH
     * @return {Number} window高さ
     */
    getWinH(){
        return window.innerHeight;
    }

    /**
     * getOffsetTop
     * @type {String} element 対象要素
     * @return {Number} documentから見た相対位置
     */
    getOffsetTop(element = null){
        if (!element) { return 0; };
        const rect = element.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return rect.top + scrollTop;
    }

    /**
     * getScrollTop
     * @return {Number} スクロール値
     */
    getScrollTop(){
        return document.documentElement.scrollTop || document.body.scrollTop;
    }

    /**
     * getScrollMax
     * @return {Number} 最大スクロール値
     */
    getScrollMax(){
        const max = document.body.scrollHeight - this.getWinH();
        return max >= 0 ? max : 0;
    }

    /**
     * isSP
     * @return {boolean} window幅がspサイズでtrue
     */
    isSP(){
        if (this.getWinW() <= this.breakpoint.s) {
            return true;
        } else {
            return false;
        };
    }

    /**
     * isTablet
     * @return {boolean} window幅がspサイズでtrue
     */
    isTablet(){
        if (!this.isSP() && !this.isPC()) {
            return true;
        } else {
            return false;
        };
    }

    /**
     * isPC
     * @return {boolean} window幅がpcサイズでtrue
     */
    isPC(){
        if (this.getWinW() > this.breakpoint.m) {
            return true;
        } else {
            return false;
        };
    }

}